import script from "./TradeQuantityManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeQuantityManagement.vue?vue&type=script&setup=true&lang=js"

import "./TradeQuantityManagement.vue?vue&type=style&index=0&id=7f418a72&lang=scss"

const __exports__ = script;

export default __exports__